/* ESSENTIA: constructor de paquete de mayoreo */
(function () {
  var root = document.getElementById('arma-tu-paquete');
  var bar = document.getElementById('ess-mb-bar');
  if (!root || !bar) return;
  var MIN = 3;
  var sumT = bar.querySelector('[data-sum-title]');
  var sumS = bar.querySelector('[data-sum-sub]');
  var msg = bar.querySelector('[data-msg]');
  var bQuote = bar.querySelector('[data-quote]');
  var bCart = bar.querySelector('[data-cart]');
  var area = document.getElementById('ess-paquete');
  var manual = false;
  if (area) area.addEventListener('input', function () { manual = true; });

  function fmt(c) { return '$' + (c / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function variant(it) {
    var s = it.querySelector('.ess-mb__var');
    var o = s.tagName === 'SELECT' ? s.options[s.selectedIndex] : s;
    return { id: o.value || o.getAttribute('value'), price: +o.getAttribute('data-price'), name: o.getAttribute('data-name') };
  }
  function q(it) { return +(it.getAttribute('data-q') || 0); }
  function list() {
    var out = [];
    root.querySelectorAll('.ess-mb__item').forEach(function (it) { if (q(it) > 0) out.push({ q: q(it), v: variant(it) }); });
    return out;
  }
  function setQ(it, n) {
    n = Math.max(0, Math.min(99, n));
    it.setAttribute('data-q', n);
    it.querySelector('.ess-mb__qty span').textContent = n;
    it.classList.toggle('is-on', n > 0);
  }
  function render() {
    var l = list(), n = 0, sub = 0;
    l.forEach(function (x) { n += x.q; sub += x.q * x.v.price; });
    bar.hidden = n === 0;
    document.body.classList.toggle('ess-has-bar', n > 0);
    sumT.textContent = n + (n === 1 ? ' pieza' : ' piezas') + ' · ' + fmt(sub) + ' a precio normal';
    if (n >= MIN) {
      sumS.textContent = '¡Tu paquete califica para precio de mayoreo!';
      bQuote.className = 'ess-btn ess-btn--primary';
      bCart.className = 'ess-btn ess-btn--ghost';
      bCart.textContent = 'Comprar a precio normal';
    } else {
      var f = MIN - n;
      sumS.textContent = 'Agrega ' + f + (f === 1 ? ' pieza más' : ' piezas más') + ' para precio de mayoreo.';
      bQuote.className = 'ess-btn ess-btn--ghost';
      bCart.className = 'ess-btn ess-btn--primary';
      bCart.textContent = 'Agregar al carrito';
    }
    msg.textContent = '';
    if (area && !manual) {
      area.value = l.length ? l.map(function (x) { return x.q + ' × ' + x.v.name + ' (' + fmt(x.v.price) + ' c/u)'; }).join('\n') + '\n\nTotal: ' + n + (n === 1 ? ' pieza' : ' piezas') + ' · Subtotal a precio normal: ' + fmt(sub) : '';
    }
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-d]');
    if (b) { var it = b.closest('.ess-mb__item'); setQ(it, q(it) + (+b.getAttribute('data-d'))); render(); return; }
    var t = e.target.closest('[data-filter]');
    if (t) {
      var f = t.getAttribute('data-filter');
      root.querySelectorAll('[data-filter]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      root.querySelectorAll('.ess-mb__item').forEach(function (it) {
        it.hidden = f !== 'all' && (',' + it.getAttribute('data-tags') + ',').indexOf(',' + f + ',') === -1;
      });
    }
  });
  root.addEventListener('change', function (e) { if (e.target.classList.contains('ess-mb__var')) render(); });

  bQuote.addEventListener('click', function () {
    var c = document.getElementById('ess-cotizar');
    if (c) c.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(function () { var nm = document.getElementById('ess-q-name'); if (nm) nm.focus({ preventScroll: true }); }, 700);
  });

  bCart.addEventListener('click', function () {
    var l = list();
    if (!l.length) return;
    var label = bCart.textContent;
    bCart.disabled = true; bCart.textContent = 'Agregando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: l.map(function (x) { return { id: +x.v.id, quantity: x.q }; }) })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          msg.textContent = 'Alguna pieza no tiene suficientes existencias. Ajusta las cantidades o solicita tu cotización.';
          bCart.disabled = false; bCart.textContent = label;
          return;
        }
        window.location.href = '/cart';
      })
      .catch(function () { bCart.disabled = false; bCart.textContent = label; });
  });

  if (/[?&]from=cart/.test(window.location.search)) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (i) {
          root.querySelectorAll('.ess-mb__item').forEach(function (it) {
            var s = it.querySelector('.ess-mb__var');
            if (s.tagName === 'SELECT') {
              for (var k = 0; k < s.options.length; k++) {
                if (+s.options[k].value === i.variant_id) { s.selectedIndex = k; setQ(it, q(it) + i.quantity); }
              }
            } else if (+s.value === i.variant_id) { setQ(it, q(it) + i.quantity); }
          });
        });
        render();
      })
      .catch(function () {});
  }
  render();
})();
